import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  Renderer2,
  OnDestroy,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
} from '@angular/forms';

import { NavController, IonContent, Platform } from '@ionic/angular';

import {
  StatsService,
  PageLoaderService,
  NetworkStatusService,
  ConfigUserService,
  StorageService,
  KameleoonService,
  AnswersService,
  QuestionsService,
  StudentService,
  AppInitService,
  SessionsService,
  SeriesService,
  GamificationService,
  UserErrorHandlerService,
  CdrVersionService,
} from '@app/services';

import { CancelAsync } from './../../app/models/cancelAsync';

import { Question } from './../../app/models/question';
import { Student } from './../../app/models/student';
import { Serie } from '../../app/models/serie';
import { Session } from '../../app/models/session';
import { Answer } from './../../app/models/answer';

import { ModalController } from '@ionic/angular';

import { StudentPurshasesDetails } from '@app/app.models';
import { ModalMarketingComponent, ModalIframeComponent } from '@app/modals';

import { ToasterService, UtilsService } from '@commons/services';

import { NavigationService } from '../../app/services/navigation.service';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { SiteOpener } from '../../app/services/site-opener.service';

@EasyDebugDecorator
@Component({
  selector: 'serie-page',
  templateUrl: 'serie.page.html',
  styleUrls: ['serie.page.scss'],
})
export class SeriePage extends CancelAsync implements OnInit, OnDestroy {
  @ViewChild(IonContent, { static: true }) content: IonContent;
  @ViewChild('timerBtn') timerBtn: any;
  @ViewChild('mediaContainer') mediaContainer: any;

  @ViewChild('modalSound') modalSound: any;
  @ViewChild('modalVideo') modalVideo: any;
  @ViewChild('modalEndFirstSerie') modalEndFirstSerie: any;
  @ViewChild('modalStrike2') modalStrike2: any;
  @ViewChild('modalStrike5') modalStrike5: any;
  @ViewChild('modalStrike10') modalStrike10: any;
  @ViewChild('modalQuitExam') modalQuitExam: any;
  @ViewChild('modalPubCpf') modalPubCpf: any;
  @ViewChild('modalPubBva') modalPubBva: any;
  @ViewChild('modalPubPackPermis') modalPubPackPermis: any;

  lockedFeatures = ['series/', 'statistiques'];

  student: Student = null;
  userLifeCycle: any;
  configUser: any;

  isDesktop = window.innerWidth > 767 ? true : false;

  pageTitle = 'Séries';
  activeLink = 'code';
  serieType = 'entrainements';

  blocHeaderTitle = 'Série';
  blocHeaderBackTitle = '';
  blocHeaderBackUrl = '';

  serieId: string;
  questionIndex: any;
  sessionId: string;
  serie: Serie;
  getSerieFailed = false;
  question: Question;
  getQuestionFailed = false;
  seriesList: Array<Serie> = [];
  sessions: Array<Session> = [];
  getSessionsFailed = false;
  session: Session;
  getSessionFailed = false;
  sessionSerie: Array<Session> = [];
  utilsSeries: any = [];

  questionForm: UntypedFormGroup;
  dynamicFormData = [];
  optionsChecked = [];
  formChangesSubscriber = null;
  displayMajCode2023 = false;
  displayRestartCode2023 = false;
  displayErrorCode2023 = false;
  majModalDisplayed = false;

  percentProgression = 0;

  firstSerieEver = false;
  firstQuestionEver = false;

  nbAnswersRef = 40;
  sendingAnswer = false;
  answered = false;
  answeredValid = false;
  showAnswers = false;
  showCorrection = true;
  showLastResultComp = false;
  notAnswered = false;

  isAlreadyAnswered = false;

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  showReloadBtn = false;
  soundMuted = false;

  // exam timer
  showTimer = false;
  maxTime = 20;
  timeSpent = 0;
  timerTimeOut = null;

  // MODALS
  modalShown = false;

  displayModalPubBva = false;
  displayModalPubBdc = false;
  displayModalPubCpf = false;
  displayModalPubPackPermis = false;
  displayModalSound = false;
  displayModalEndFirstSerie = false;
  displayModalStrike2 = false;
  displayModalStrike5 = false;
  displayModalStrike10 = false;
  displayModalQuitExam = false;
  displayModalVideo = false;
  showCtaPostVideo = false;
  canQuitExam = false;

  paused = false;
  displayModalDeleteSession = false;

  objectKeys = Object.keys;

  // MEDIA

  questions: Question[] = [];
  questionVideo: Question = null;
  questionGif: Question = null;
  questionImg: Question = null;
  isDebug = false;
  isPaused = false;
  isMuted = false;
  isStoped = false;
  isReloaded = false;
  displayMode = null;
  isEnded = false;
  type = 'question';

  imgPath = '';
  imgSizeType = 'medium';
  sizesByImgSizeType = {
    medium: 269,
  };
  screenSizeX = window.innerWidth;
  maxWidthImg = 767;
  maxHeightImg = 326;
  maxHeightImgPano = 269;
  ratioImg = this.screenSizeX / this.maxWidthImg;
  mediaWidth = this.maxWidthImg * this.ratioImg;
  mediaHeight = this.maxHeightImg * this.ratioImg;
  retry = 0;

  serieLockedForGuest = false;

  seriePageSubscription: any;
  kamSub: any;
  withPub = false;
  showSpiner = false;

  mediaType: any;

  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;
  canZendesk = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;
  isMediaFullscreen = false;
  needRedirect = false;

  videosPubs = [
    {
      modal: 'cpf',
      src: 'https://storage.googleapis.com/evs-public-videos/CPF_APP_9x16_VIERGE.mov',
      marketData: {
        item_id: 'permis_cpf',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'CPF_APP_9x16_VIERGE',
      },
    },
    {
      modal: 'cpf',
      src: 'https://storage.googleapis.com/evs-public-videos/CPF - Magic trick_9x16_VIERGE.mp4',
      marketData: {
        item_id: 'permis_cpf',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'CPF_Magic trick_9x16_VIERGE',
      },
    },
    {
      modal: 'bdc',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - Lead BDC_9x16.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_Lead_BDC_9-16',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - Pas-loin-pas-cher_9X16_VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_Pas-loin-pas-cher_9-16-VIERGE',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PRES_DE_TOI_9x16_VIERGE.mov',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_PRES_DE_TOI_9x16_VIERGE',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - 3xsans frais_9x16_VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_3xsans frais_9x16_VIERGE',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - 9x16 - Reportage TV permis sous-titre-VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_9x16_Reportage TV permis sous-titre-VIERGE',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - Top chrono_9x16_VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_Top chrono_9x16_VIERGE',
      },
    },
    {
      modal: 'permis',
      src: 'https://storage.googleapis.com/evs-public-videos/PERMIS - Youtuber like 2024_9x16_VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'PERMIS_Youtuber like 2024_9x16_VIERGE',
      },
    },
    {
      modal: 'bva',
      src: 'https://storage.googleapis.com/evs-public-videos/BVA_SANS_STRESS_9x16-VIERGE.mp4',
      marketData: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'liste_serie_simples_',
        item_location_format: 'video',
        item_promo_content: 'BVA_SANS_STRESS_9x16-VIERGE',
      },
    },
  ];
  videoMarketing =
  this.videosPubs[this.utils.randomMinMax(0, this.videosPubs.length - 1)];
  videoSrc = this.videoMarketing.src;
  videoModal = this.videoMarketing.modal;
  videoMarketData = this.videoMarketing.marketData;
  showVideoElt = false;
  videoPaused = true;
  showMarketVideo = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
    this.setMediaContainer();
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    public navController: NavController,
    public navigationService: NavigationService,
    public appInitService: AppInitService,
    private statsService: StatsService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private modalController: ModalController,
    private utils: UtilsService,
    private networkService: NetworkStatusService,
    private seriesService: SeriesService,
    private sessionsService: SessionsService,
    private toasterService: ToasterService,
    private studentService: StudentService,
    public formBuilder: UntypedFormBuilder,
    public renderer: Renderer2,
    private answersService: AnswersService,
    private configUserService: ConfigUserService,
    private storageService: StorageService,
    private questionsService: QuestionsService,
    private platform: Platform,
    private gamificationService: GamificationService,
    private userErrorHandlerService: UserErrorHandlerService,
    private kameleoonService: KameleoonService,
    private cdrVersionService: CdrVersionService,
    private siteOpener: SiteOpener,
  ) {
    super({ cancel: false, subscription: null });

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.kamSub = this.kameleoonService.testABVideoPub$.subscribe(data => {
      if (!!data && !!data.withPub && data.withPub) {
        this.withPub = true;
        // DEBUG START
        if (!this.networkService?.isOffline()) {
          if (this.withPub) {
            console.log('SHOW PUB VIDEO');
            this.showMarketVideo = true;
          } else {
            this.showMarketVideo = false;
          }
        } else {
          this.showMarketVideo = false;
        }
        // DEBUG END
      }
    });

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    this.serieType = this.activatedRoute.snapshot.paramMap.get('type');
    this.serieId = this.activatedRoute.snapshot.paramMap.get('serieId');
    this.questionIndex =
      this.activatedRoute.snapshot.paramMap.get('questionIndex');
    this.questionIndex = Number(this.questionIndex);
    if (this.serieType === 'erreurs') {
      this.questionIndex = 0;
    }
    this.sessionId = this.activatedRoute.snapshot.paramMap.get('sessionId');
    const titles = {
      entrainements: 'Entraînements',
      examens: 'Examens blancs',
      thematiques: 'Séries thématiques',
    };
    this.blocHeaderBackTitle = titles[this.serieType];
    this.blocHeaderBackUrl = 'series/' + this.serieType;
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.seriePageSubscription) {
      this.seriePageSubscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.kamSub) {
      this.kamSub.unsubscribe();
    }
    if (!!this.formChangesSubscriber) {
      this.formChangesSubscriber.unsubscribe();
    }
    if (!!this.timerTimeOut) {
      clearTimeout(this.timerTimeOut);
      this.timerTimeOut = null;
    }
  }

  async initPage() {
    this.student = this.studentService.student;
    this.configUser = await this.configUserService.getUserConfig(this.student);

    if (this.student.isGuest()) {
      this.gamificationService.unlockBadgeInStorage('start_cdr_serie');
    }

    if (!this.student.isGuest() && this.networkService?.isOffline()) {
      if (this.serieType === 'entrainements') {
        this.gamificationService.addBadgeObtainedOffline('start_cdr_serie');
      }

      if (this.serieType === 'examens') {
        this.gamificationService.addBadgeObtainedOffline(
          'start_cdr_serie_exam'
        );
      }

      if (this.serieType === 'thematiques') {
        this.gamificationService.addBadgeObtainedOffline(
          'start_cdr_serie_thematic'
        );
      }
    }

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    if (
      !!this.seriesService.currentSerie &&
      !!this.seriesService.currentSerie.id &&
      this.seriesService.currentSerie.id === this.serieId &&
      this.serieType !== 'erreurs'
    ) {
      this.serie = this.seriesService.currentSerie;
    } else {
      const resGetSerie = await this.seriesService.seriesContext.getSerie(
        this.serieId,
        this.student,
        true
      );
      if (
        !!resGetSerie &&
        !!resGetSerie.errorCode &&
        resGetSerie.errorCode === 'E301'
      ) {
        this.serie = null;
        this.getSerieFailed = true;
        // this.userErrorHandlerService.addError({criticity: 20, service: 'getSerie', platform: 'both', data: resGetSerie.errorOriginal, errorCode: 'ssfsr'});
      } else {
        this.seriesService.currentSerie = resGetSerie;
        this.serie = this.seriesService.currentSerie;
      }
    }
    this.getPayments();

    if (this.userLifeCycle.isUserGuest && this.questionIndex >= 3) {
      this.serieLockedForGuest = true;
      const link =
        'series/' +
        this.serieType +
        '/' +
        this.serieId +
        '/' +
        this.questionIndex +
        '/' +
        this.sessionId;
      await this.storageService.set('redirectAfterLogIn', link);
      // console.log('redirect saved => ', link);
      // console.log('user guest question > 3 showMarketVideo => ', this.showMarketVideo);
      if (this.showMarketVideo) {
        this.displayModalVideo = true;
        this.videoMarketData.item_location_id =
          this.videoMarketData.item_location_id + this.serie.position;
        this.statsService.send({
          name: 'item:viewed',
          payload: {
            item: this.videoMarketData,
          },
        });
      } else {
        this.openModalPack(null, 'modalSeriesGuest');
      }
    }

    // redirect disconencted for offline guest & registered users
    if (this.userLifeCycle.isUserGuest) {
      if (this.networkService?.isOffline()) {
        this.navigationService.saveLinkToReload();
      }
    }

    if (!!this.serie) {
      if (!!this.serie.type && this.serie.type === 'Discovery') {
        this.nbAnswersRef = 10;
      }
      this.percentProgression = this.utils.getPercent(
        this.questionIndex,
        this.nbAnswersRef
      );

      const resGetQuestion =
        await this.questionsService.questionsContext.getQuestion(
          this.serie.questions[this.questionIndex],
          this.student
        );
      if (
        !!resGetQuestion &&
        !!resGetQuestion.errorCode &&
        resGetQuestion.errorCode === 'E301'
      ) {
        this.question = null;
        this.getQuestionFailed = true;
      } else {
        this.question = resGetQuestion;
        console.log('question => ', this.question);
      }
      if (!!this.question && !!this.question.id) {
        const resgetSessions =
          await this.sessionsService.sessionsContext.getSessions(this.student);
        if (
          !!resgetSessions &&
          !!resgetSessions.errorCode &&
          resgetSessions.errorCode === 'E301'
        ) {
          this.getSessionsFailed = true;
          // this.userErrorHandlerService.addError({criticity: 30, service: 'fetchSessions', platform: 'both', data: resgetSessions.errorOriginal, errorCode: 'ssfss'});
        } else {
          this.sessions = resgetSessions;
        }
        const resgetSession =
          await this.sessionsService.sessionsContext.getSession(
            this.sessionId,
            this.student
          );
        if (
          !!resgetSession &&
          !!resgetSession.errorCode &&
          resgetSession.errorCode === 'E301'
        ) {
          this.session = null;
          this.getSessionFailed = true;
          // this.userErrorHandlerService.addError({criticity: 30, service: 'fetchSessions', platform: 'both', data: resgetSessions.errorOriginal, errorCode: 'ssfss'});
        } else {
          this.session = resgetSession;
        }
        this.isMuted = this.configUser.mute;
        // console.log(JSON.stringify(this.sessions));
        // console.log('serie', this.serie);
        // console.log('question', this.question, this.serie.questions[this.questionIndex]);
        this.nbAnswersRef = this.serie.nbQuestions;
        this.blocHeaderTitle = 'Série ' + (this.serie.position + 1);
        this.setMediaContainer();
        this.setQuestionsForm();
        this.checkFirstSerie();

        if (this.serieType !== 'thematiques') {
          if (this.serieType !== 'erreurs') {
            this.blocHeaderTitle =
              'Série ' +
              (this.serie.position + 1) +
              ' - Question ' +
              (this.questionIndex + 1) +
              '/' +
              this.nbAnswersRef;
          } else if (this.serieType === 'erreurs') {
            this.blocHeaderTitle =
              'Erreurs restantes : ' + this.serie.nbQuestions;
          }
        } else {
          const serieTheme = !!this.serie.theme ? this.serie.theme : 'Autres';
          this.blocHeaderTitle =
            'Série ' +
            serieTheme +
            ' - Question ' +
            (this.questionIndex + 1) +
            '/' +
            this.nbAnswersRef;
        }
      } else {
        if (this.networkService?.isOffline()) {
          this.navigationService.saveLinkToReload();
        } else {
          this.getQuestionFailed = true;
        }
      }
    } else {
      this.getSerieFailed = true;
    }
    this.seriePageSubscription.unsubscribe();

    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      let lastLink = this.navigationService.lastLink;
      if (!!this.serie && this.serie.type === 'Discovery') {
        lastLink = this.navigationService.lastLink.replace(
          'entrainements',
          'discovery'
        );
      }
      const statObj = {
        page: lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        // console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }
  }

  async ngOnInit() {}

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();
    this.canZendesk = this.studentPurshases.canZendesk();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  async showModalPub() {
    if (
      (this.userLifeCycle.isUserRegistered &&
        (this.serieType === 'entrainements' ||
          this.serieType === 'thematiques')) ||
      (this.userLifeCycle.isUserEngaged &&
        (this.serieType === 'entrainements' ||
          this.serieType === 'thematiques') &&
        !this.isPackPermis)
    ) {
      if (!!this.configUser) {
        let serieFound = null;
        const randomValue = this.utils.randomMinMax(1, this.serie.nbQuestions);
        const randomMatch =
          randomValue === this.questionIndex + 1 ? true : false;
        const answers = this.session.answers;
        let nbGoodAnswers = 0;
        if (
          !!this.session &&
          !!this.session.stats &&
          !!this.session.stats.goodAnswers
        ) {
          nbGoodAnswers = this.session.stats.goodAnswers;
        }
        // debug/test
        // console.log(this.studentPurshases);
        // this.openModalPub(nbGoodAnswers, 'modalPubEntrainenements');
        // return;
        // check if modal has been laready shown for this session of serie
        if (!!this.configUser.modalSeries) {
          serieFound = this.configUser.modalSeries.find(
            elt =>
              elt.serieId === this.serieId &&
              elt.sessionId === this.sessionId &&
              elt.type === this.serieType
          );
        }
        if (!serieFound) {
          // force showing modal if never shown before & last question
          if (
            (randomMatch || answers.length === this.serie.nbQuestions - 1) &&
            nbGoodAnswers > 0
          ) {
            if (!this.configUser.modalSeries) {
              this.configUser.modalSeries = [];
            }
            this.configUser.modalSeries.push({
              serieId: this.serieId,
              sessionId: this.sessionId,
              type: this.serieType,
            });
            await this.configUserService.setUserConfig(
              this.student,
              this.configUser
            );
            // console.log('modal pub showMarketVideo => ', this.showMarketVideo);
            if (this.showMarketVideo) {
              this.displayModalVideo = true;
              this.videoMarketData.item_location_id =
                'liste_serie_simples_' + this.serie.position;
              this.statsService.send({
                name: 'item:viewed',
                payload: {
                  item: this.videoMarketData,
                },
              });
            } else {
              this.openModalPub(nbGoodAnswers, 'modalPubEntrainenements');
            }
          }
        }
      }
    } else if (
      this.userLifeCycle.isUserEngaged &&
      this.serieType === 'erreurs' &&
      !this.isPackPermis
    ) {
      let serieFound = null;
      if (!!this.configUser.modalSeries) {
        serieFound = this.configUser.modalSeries.find(
          elt =>
            elt.serieId === this.serieId &&
            elt.sessionId === this.sessionId &&
            elt.type === this.serieType
        );
      }
      if (!serieFound) {
        if (!this.configUser.modalSeries) {
          this.configUser.modalSeries = [];
        } else {
          this.configUser.modalSeries.push({
            serieId: this.serieId,
            sessionId: this.sessionId,
            type: this.serieType,
            counter: 0,
            nbErrors: this.serie.nbQuestions,
          });
          await this.configUserService.setUserConfig(
            this.student,
            this.configUser
          );
        }
      } else {
        // update counter
        serieFound.counter++;
        if (serieFound.counter % 15 === 0) {
          const nbGoodanswers = serieFound.nbErrors - this.serie.nbQuestions;
          serieFound.nbErrors = this.serie.nbQuestions; // reset to calculate diff for next modulo
          if (nbGoodanswers > 0) {
            // show only if positive
            this.openModalPub(nbGoodanswers, 'modalPubEntrainenements');
          }
        }
        await this.configUserService.setUserConfig(
          this.student,
          this.configUser
        );
      }
    }
  }

  checkFirstSerie() {
    // console.log('CheckFirstSerie()');
    if (this.serieType === 'entrainements') {
      // console.log('sessions', this.sessions);
      if (!!this.sessions && this.sessions.length > 0) {
        // only first Serie
        if (this.sessions.length === 1) {
          this.sessionSerie = this.sessions.filter(
            elt => elt.serieId === this.serieId
          );
          // console.log('sessionSerie', this.sessionSerie);
          // serie found in Sessions + only 1 time
          if (this.sessionSerie.length === 1) {
            // console.log('FIRST SERIE EVER');
            this.firstSerieEver = true;
            if (this.sessionSerie[0].answers.length === 1) {
              // First question answered
              // console.log('FIRST QUESTION EVER');
              this.firstQuestionEver = true;
            } else {
              this.firstQuestionEver = false;
            }
            if (!this.userLifeCycle.isUserGuest) {
              // à la 3ème question avant qu'on ai répondu donc au lancement de la question
              if (this.sessionSerie[0].answers.length === 3 && !this.answered) {
                this.soundMuted = true;
                this.displayModalSound = true;
                this.modalShown = true;
                // console.log('MODAL SOUND');
              }
              // check if 2 consecutive good answers
              if (this.sessionSerie[0].answers.length >= 2) {
                // console.log('this.sessionSerie[0].answers.length >= 2');
                let from = null;
                let validFrom = null;
                let validTo = null;
                let nbStrikes = 0;
                for (let i = 0; i < this.sessionSerie[0].answers.length; i++) {
                  if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from === null
                  ) {
                    from = i;
                  } else if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from !== null
                  ) {
                    if (i - from === 1) {
                      validFrom = from;
                      validTo = i;
                      break;
                    }
                  } else if (
                    this.sessionSerie[0].answers[i].state !== 'right' &&
                    from !== null
                  ) {
                    if (i - 1 - from === 1) {
                      validFrom = from;
                      validTo = i - 1;
                      break;
                    } else {
                      from = null;
                    }
                  }
                }

                if (validFrom !== null && validTo !== null) {
                  nbStrikes = validTo - validFrom + 1;

                  // console.log('nbStrikes', nbStrikes);
                  // console.log('validTo', validTo);
                  // console.log('questionIndex', this.questionIndex);
                  // console.log('showAnswers', this.showAnswers);

                  if (nbStrikes === 2 && validTo === this.questionIndex) {
                    // show modal only when response is showned
                    if (this.showAnswers) {
                      // console.log('MODAL STREAK 2');
                      this.soundMuted = true;
                      // console.log('strike 2 showMarketVideo => ', this.showMarketVideo);
                      if (this.showMarketVideo) {
                        this.displayModalVideo = true;
                        this.videoMarketData.item_location_id =
                          this.videoMarketData.item_location_id +
                          this.serie.position;
                        this.statsService.send({
                          name: 'item:viewed',
                          payload: {
                            item: this.videoMarketData,
                          },
                        });
                      } else {
                        this.displayModalStrike2 = true;
                      }
                      this.modalShown = true;
                    }
                  }
                }
              }
              // check if 5 consecutive good answers
              if (this.sessionSerie[0].answers.length >= 5) {
                let from = null;
                let validFrom = null;
                let validTo = null;
                let nbStrikes = 0;
                for (let i = 0; i < this.sessionSerie[0].answers.length; i++) {
                  if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from === null
                  ) {
                    from = i;
                  } else if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from !== null
                  ) {
                    if (i - from === 4) {
                      validFrom = from;
                      validTo = i;
                      break;
                    }
                  } else if (
                    this.sessionSerie[0].answers[i].state === 'false' &&
                    from !== null
                  ) {
                    if (i - 1 - from === 4) {
                      validFrom = from;
                      validTo = i - 1;
                      break;
                    } else {
                      from = null;
                    }
                  }
                }

                if (validFrom !== null && validTo !== null) {
                  nbStrikes = validTo - validFrom + 1;
                  if (nbStrikes === 5 && validTo === this.questionIndex) {
                    // show modal only when response is showned
                    if (this.showAnswers) {
                      // console.log('MODAL STREAK 5');
                      // console.log('strike 5 showMarketVideo => ', this.showMarketVideo);
                      this.soundMuted = true;
                      if (this.showMarketVideo) {
                        this.displayModalVideo = true;
                        this.videoMarketData.item_location_id =
                          this.videoMarketData.item_location_id +
                          this.serie.position;
                        this.statsService.send({
                          name: 'item:viewed',
                          payload: {
                            item: this.videoMarketData,
                          },
                        });
                      } else {
                        this.displayModalStrike5 = true;
                      }
                      this.modalShown = true;
                    }
                  }
                }
              }

              // check if 10 consecutive good answers
              if (this.sessionSerie[0].answers.length >= 10) {
                let from = null;
                let validFrom = null;
                let validTo = null;
                let nbStrikes = 0;
                for (let i = 0; i < this.sessionSerie[0].answers.length; i++) {
                  if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from === null
                  ) {
                    from = i;
                  } else if (
                    this.sessionSerie[0].answers[i].state === 'right' &&
                    from !== null
                  ) {
                    if (i - from === 9) {
                      validFrom = from;
                      validTo = i;
                      break;
                    }
                  } else if (
                    this.sessionSerie[0].answers[i].state === 'false' &&
                    from !== null
                  ) {
                    if (i - 1 - from === 9) {
                      validFrom = from;
                      validTo = i - 1;
                      break;
                    } else {
                      from = null;
                    }
                  }
                }

                if (nbStrikes === 2 && validTo === this.questionIndex) {
                  nbStrikes = validTo - validFrom + 1;
                  if (nbStrikes === 10 && validTo === this.questionIndex) {
                    // show modal only when response is showned
                    if (this.showAnswers) {
                      // console.log('MODAL STREAK 10');
                      this.soundMuted = true;
                      // console.log('strike 10 showMarketVideo => ', this.showMarketVideo);
                      if (this.showMarketVideo) {
                        this.displayModalVideo = true;
                        this.videoMarketData.item_location_id =
                          this.videoMarketData.item_location_id +
                          this.serie.position;
                        this.statsService.send({
                          name: 'item:viewed',
                          payload: {
                            item: this.videoMarketData,
                          },
                        });
                      } else {
                        this.displayModalStrike10 = true;
                      }
                      this.modalShown = true;
                    }
                  }
                }
              }
            }
          } else {
            this.firstSerieEver = false;
          }
        } else {
          this.firstSerieEver = false;
        }
      }
    }
  }

  // shortcut for view template
  get getQuestionForm() {
    return this.questionForm.controls;
  }

  setQuestionsForm() {
    this.questionForm = this.formBuilder.group({});
    const answers = ['a', 'b', 'c', 'd'];
    let possible_values = [];
    const nbQuestions = !!this.question.text2 ? 2 : 1;
    let cpt = 1;
    let questionNumber = 1;
    this.dynamicFormData = []; // reset
    this.questionForm.addControl(
      'question' + questionNumber,
      new UntypedFormControl([])
    );
    this.questionForm.controls['question' + questionNumber].setValidators(
      Validators.required
    );
    this.questionForm.controls[
      'question' + questionNumber
    ].updateValueAndValidity();
    for (const reponse of answers) {
      if (this.question['answer_' + reponse]) {
        if (cpt === 3) {
          if (nbQuestions > 1) {
            this.dynamicFormData.push({
              field_name: 'question' + questionNumber,
              possible_values: possible_values,
              text: this.question['text' + questionNumber],
            });
            this.optionsChecked['question' + questionNumber] = [];
            possible_values = [];
            questionNumber++;
            this.questionForm.addControl(
              'question' + questionNumber,
              new UntypedFormControl([])
            );
            this.questionForm.controls[
              'question' + questionNumber
            ].setValidators(Validators.required);
            this.questionForm.controls[
              'question' + questionNumber
            ].updateValueAndValidity();
          }
        }
        possible_values.push({
          value: reponse.toUpperCase(),
          text: this.question['answer_' + reponse],
        });
        cpt++;
      }
    }
    this.dynamicFormData.push({
      field_name: 'question' + questionNumber,
      possible_values: possible_values,
      text: this.question['text' + questionNumber],
    });
    this.optionsChecked['question' + questionNumber] = [];
    // console.log(this.questionForm, this.dynamicFormData);
  }

  onCheckboxesChange(event) {
    if (this.sendingAnswer) {
      return;
    }
    const checkedOptionIndex = this.optionsChecked[event.field].indexOf(
      event.value
    );
    if (checkedOptionIndex < 0) {
      this.optionsChecked[event.field].push(event.value);
    } else {
      this.optionsChecked[event.field].splice(checkedOptionIndex, 1);
    }
    this.questionForm.controls[event.field].patchValue(
      this.optionsChecked[event.field].sort()
    );
    this.questionForm.controls[event.field].updateValueAndValidity();

    setTimeout(() => {
      for (const field of this.dynamicFormData) {
        const fieldName = field.field_name;
        for (const possibleValues of field.possible_values) {
          const checkbox: any = document.getElementById(
            fieldName + '_' + possibleValues.value
          );
          // console.log(fieldName, possibleValues.value);
          // console.log('includes', this.questionForm.value[fieldName].includes(possibleValues.value));
          // console.log('checkbox.checked', checkbox.checked);
          if (
            this.questionForm.value[fieldName].includes(possibleValues.value) &&
            !checkbox.checked
          ) {
            checkbox.checked = true;
          } else if (
            !this.questionForm.value[fieldName].includes(
              possibleValues.value
            ) &&
            checkbox.checked
          ) {
            checkbox.checked = false;
          }
          // console.log(checkbox, checkbox.checked);
        }
      }
    }, 20);
  }

  async submitAnswer() {
    this.notAnswered = false;
    let notAnswered = true;
    for (const key of Object.keys(this.questionForm.value)) {
      for (const reponse of this.questionForm.value[key]) {
        if (reponse !== '') {
          notAnswered = false;
        }
      }
    }
    this.notAnswered = !notAnswered ? false : true;
    this.sendingAnswer = true; // loading button
    this.checkAnswers();
    this.stopTimer();
    await this.saveAnswer('submitAnswer');
    // console.log('answer submited');
    this.sendingAnswer = false; // loading button
    if (
      this.serieType === 'entrainements' ||
      this.serieType === 'thematiques' ||
      this.serieType === 'erreurs'
    ) {
      this.type = 'answer';
      this.showAnswers = true;
      if (this.serie.type !== 'Discovery') {
        this.showModalPub();
      }

      // console.log('showAnswers', this.showAnswers);
      this.checkFirstSerie();
    }

    if (this.student.isGuest()) {
      this.gamificationService.guestSerieInfoAnswers += 1;

      if (this.answeredValid) {
        this.gamificationService.guestSerieInfoGoodAnswers += 1;
        this.gamificationService.guestSerieInfoGoodAnswersInARow += 1;
      } else {
        this.gamificationService.guestSerieInfoGoodAnswersInARow = 0;
      }

      await this.gamificationService.setStorageGuestSerieInfo();
      await this.gamificationService.validateGuestSerieBadges();
    }

    if (!this.student.isGuest()) {
      this.gamificationService.studentSerieInfoAnswers += 1;

      if (this.answeredValid) {
        this.gamificationService.studentSerieInfoGoodAnswers += 1;
        this.gamificationService.studentSerieInfoGoodAnswersInARow += 1;

        if (this.networkService?.isOffline() && this.serieType === 'erreurs') {
          this.gamificationService.addBadgeObtainedOffline('fix_cdr_error');
        }
      } else {
        this.gamificationService.studentSerieInfoGoodAnswersInARow = 0;
      }

      await this.gamificationService.setStorageStudentSerieInfo();

      if (this.networkService?.isOffline()) {
        await this.gamificationService.validateStudentSerieBadgesObtainedOffline();
      }
    }
  }

  async majCode2023(skip: boolean) {
    console.log('skip ? ', skip);
    if (!skip) {
      this.showSpiner = true;
      const resMaj = await this.cdrVersionService.handleMajCode2023();
      if (!resMaj) {
        this.showSpiner = false;
        this.displayMajCode2023 = false;
        this.majModalDisplayed = false;
        this.displayErrorCode2023 = true;
      } else {
        this.showSpiner = false;
        this.displayMajCode2023 = false;
        this.majModalDisplayed = false;
        this.openLink('code');
      }
    }
  }

  async restartCode2023() {
    console.log('restartCode2023');
    this.displayRestartCode2023 = false;
    const resMaj = await this.cdrVersionService.handleMajCode2023();
    if (!resMaj) {
      this.displayErrorCode2023 = true;
    } else {
      this.openLink('code');
    }
  }

  async deleteSessions() {
    await this.sessionsService.deleteSession(this.sessionId);
    if (this.serieType === 'erreurs') {
      let localSessions = [];
      const resgetSessions2 =
        await this.sessionsService.sessionsContext.getSessions(
          this.studentService.student
        );
      if (
        !!resgetSessions2 &&
        !!resgetSessions2.errorCode &&
        resgetSessions2.errorCode === 'E301'
      ) {
        this.getSessionsFailed = true;
        this.userErrorHandlerService.addError({
          criticity: 30,
          service: 'fetchSessions',
          platform: 'both',
          data: resgetSessions2.errorOriginal,
          errorCode: 'ssfss',
        });
      } else {
        localSessions = resgetSessions2;
      }
      let errorSessions = [];
      if (localSessions.length > 0) {
        errorSessions = localSessions.filter(elt => elt.type === 'Error');
      }
      if (!!errorSessions && errorSessions.length > 0) {
        for (const errorSession of errorSessions) {
          if (!!errorSession) {
            await this.sessionsService.deleteSession(errorSession.id);
          }
        }
      }
      let session = [];
      const resgetSessions =
        await this.sessionsService.sessionsContext.getSessions(this.student);
      if (
        !!resgetSessions &&
        !!resgetSessions.errorCode &&
        resgetSessions.errorCode === 'E301'
      ) {
        this.getSessionsFailed = true;
        this.userErrorHandlerService.addError({
          criticity: 30,
          service: 'fetchSessions',
          platform: 'both',
          data: resgetSessions.errorOriginal,
          errorCode: 'ssfss',
        });
      } else {
        session = resgetSessions;
      }
    }
    this.displayModalDeleteSession = false;
    if (this.serieType === 'erreurs') {
      this.openLink('code');
    } else {
      this.openLink('series/' + this.serieType, { forceRoot: true });
    }
  }

  async saveAnswer(source: string) {
    if (!this.answered) {
      // console.log(this.questionForm.value, this.student, this.question, this.sessionId, this.serie.id);
      const answer = await this.answersService.sendAnswer(
        this.questionForm.value,
        this.student,
        this.question,
        this.sessionId,
        this.serie.id,
        source
      );
      // console.log('SERIE PAGE -> saveAnswer -> answer', JSON.stringify(answer));
      if (answer?.id === 'delSession') {
        // NEED SESSION DELETE
        this.displayModalDeleteSession = true;
      }
      if (answer?.id === 'launchMaj') {
        // DISPLAY MODAL MAJ
        this.displayMajCode2023 = true;
      }
      // console.log('saved Answer => ', answer);
      if (
        answer?.id !== 'error' &&
        answer?.id !== 'delSession' &&
        answer?.id !== 'launchMaj'
      ) {
        this.session = await this.answersService.saveAnswer(
          answer,
          this.sessionId,
          this.serieType
        );
        // console.log('session => ', this.session);
      }
      this.answered = true;
      this.checkFirstSerie();
    }
    if (this.serieType === 'examens') {
      this.handleNextQuestion();
    }
  }

  getUnansweredQuestion(questions: string[], answers: Answer[]): string {
    // console.log('getUnansweredQuestion questions', questions);
    // console.log('getUnansweredQuestion answers', answers);
    const questionAnswered = [];
    answers.map(answer => {
      questionAnswered.push(answer.questionId);
    });

    for (const question of questions) {
      if (!questionAnswered.includes(question)) {
        return question;
      }
    }
    return null;
  }

  async handleNextQuestion() {
    const answers = this.session.answers;
    const questionsId = this.serie.questions;
    if (this.serieType === 'erreurs') {
      if (this.answeredValid) {
        if (this.serie.nbQuestions > 1) {
          this.openLink(
            'series/' +
              this.serieType +
              '/' +
              this.serieId +
              '/' +
              Date.now() +
              '/' +
              this.sessionId,
            { forceRoot: true }
          );
        } else {
          this.statsService.send({
            name: 'session:completed',
            payload: { serie: this.serie },
          });
          this.openLink(
            'series/' +
              this.serieType +
              '/' +
              this.serieId +
              '/results/' +
              this.sessionId,
            { forceRoot: true }
          );
        }
      } else {
        this.openLink(
          'series/' +
            this.serieType +
            '/' +
            this.serieId +
            '/' +
            Date.now() +
            '/' +
            this.sessionId,
          { forceRoot: true }
        );
      }
    } else {
      if (this.userLifeCycle.isUserGuest && this.questionIndex === 2) {
        const link =
          'series/' +
          this.serieType +
          '/' +
          this.serieId +
          '/' +
          this.questionIndex +
          '/' +
          this.sessionId;
        await this.storageService.set('redirectAfterLogIn', link);
        // console.log('guest question 2 showMarketVideo => ', this.showMarketVideo);
        if (this.showMarketVideo) {
          this.displayModalVideo = true;
          this.videoMarketData.item_location_id =
            this.videoMarketData.item_location_id + this.serie.position;
          this.statsService.send({
            name: 'item:viewed',
            payload: {
              item: this.videoMarketData,
            },
          });
        } else {
          this.openModalPack(null, 'modalSeriesGuest');
        }
        return;
      }
      // console.log('getUnansweredQuestion', this.getUnansweredQuestion(questionsId, answers));
      if (!!this.getUnansweredQuestion(questionsId, answers)) {
        const index = this.serie.questions.indexOf(
          this.getUnansweredQuestion(questionsId, answers)
        );
        console.log('next index', index);
        // console.log('series/' + this.serieType + '/' + this.serieId + '/' + index + '/' + this.sessionId, { forceRoot: true });
        this.openLink(
          'series/' +
            this.serieType +
            '/' +
            this.serieId +
            '/' +
            index +
            '/' +
            this.sessionId,
          { forceRoot: true }
        );
      } else {
        // finished serie
        this.statsService.send({
          name: 'session:completed',
          payload: { serie: this.serie },
        });
        this.checkFirstSerie();
        if (!this.firstSerieEver) {
          this.openLink(
            'series/' +
              this.serieType +
              '/' +
              this.serieId +
              '/results/' +
              this.sessionId,
            { forceRoot: true }
          );
        } else {
          this.content.scrollToPoint(0, 0);
          // console.log('displayModalEndFirstSerie showMarketVideo => ', this.showMarketVideo);
          if (this.showMarketVideo) {
            this.displayModalVideo = true;
            this.videoMarketData.item_location_id =
              this.videoMarketData.item_location_id + this.serie.position;
            this.statsService.send({
              name: 'item:viewed',
              payload: {
                item: this.videoMarketData,
              },
            });
          } else {
            this.displayModalEndFirstSerie = true;
          }
          this.modalShown = true;
        }
      }
    }
  }

  isAnswered(question, answer) {
    const condition = answer.indexOf(question) !== -1 ? true : false;
    return condition;
  }

  isValidAnswer(question: any) {
    return this.question.correctAnswers.indexOf(question) !== -1 ? 'ok' : 'ko';
  }

  isUserValidAnswer(question, answer) {
    const questionAnswered = this.isAnswered(question, answer);
    let condition = null;
    if (questionAnswered) {
      condition =
        this.question.correctAnswers.indexOf(question) !== -1 ? 'ok' : 'ko';
    }
    return condition;
  }

  checkAnswers() {
    const userAnswers = [];
    for (const key of Object.keys(this.questionForm.value)) {
      for (const reponse of this.questionForm.value[key]) {
        userAnswers.push(reponse);
      }
    }
    this.answeredValid =
      userAnswers.join('') === this.question.correctAnswers.join('')
        ? true
        : false;
  }

  toggleCorrection() {
    this.showCorrection = !this.showCorrection;
  }

  toggleSound() {
    this.soundMuted = !this.soundMuted;
  }

  startTimer() {
    if (this.serieType === 'examens') {
      this.showTimer = true;
      if (
        !!this.timerBtn &&
        !!this.timerBtn.nativeElement &&
        this.timerBtn.nativeElement.style.animationPlayState === ''
      ) {
        this.renderer.setStyle(
          this.timerBtn.nativeElement,
          'animation-play-state',
          'running'
        );
      }

      this.timerTimeOut = setTimeout(async () => {
        if (this.answered) {
          // anti-couillons
          this.stopTimer();
          await this.saveAnswer('timer after answered');
        }
        if (this.maxTime > 0 && !this.paused) {
          this.maxTime -= 1;
          this.startTimer();
        } else if (!this.paused) {
          this.stopTimer();
          await this.saveAnswer('timer !paused');
        } else {
          this.startTimer();
        }
      }, 1000);
    }
  }

  pauseTimer() {
    if (!!this.timerBtn && !!this.timerBtn.nativeElement) {
      this.renderer.setStyle(
        this.timerBtn.nativeElement,
        'animation-play-state',
        'paused'
      );
    }
  }

  stopTimer() {
    if (this.serieType === 'examens') {
      clearTimeout(this.timerTimeOut);
      this.pauseTimer();
      this.maxTime = 20;
      this.showTimer = false;
    }
  }

  countTimeSpentOnQuestion() {
    setTimeout(() => {
      this.timeSpent++;
      this.countTimeSpentOnQuestion();
    }, 1000);
  }

  quitSerie() {
    if (this.serieType === 'examens') {
      this.pauseTimer();
      this.pauseMedia();
      this.paused = true;
      this.displayModalQuitExam = true;
      this.modalShown = true;
    } else if (this.serieType === 'erreurs') {
      this.openLink('code');
    } else {
      this.openLink('series/' + this.serieType, { forceRoot: true });
    }
  }

  callHideModalPubCpf(action?) {
    this.videoMarketData.item_location_id =
      'liste_serie_simples_' + this.serie.position;
    this.statsService.send({
      name: 'item:clicked',
      payload: {
        item: this.videoMarketData,
      },
    });
    this.modalPubCpf.closeModal();
  }

  hideModalPubCpf(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalPubCpf = false;
    this.modalShown = false;
    this.videoMarketData.item_location_id =
      'liste_serie_simples_' + this.serie.position;
    if (action === 'details') {
      this.statsService.send({
        name: 'item:clicked',
        payload: {
          item: this.videoMarketData,
        },
      });
      this.openLink('cpf');
    }
    if (action === 'nextSerie') {
      if (this.userLifeCycle.isUserGuest) {
        this.openLink('series/entrainements');
      }
    }
  }

  callHideModalPubBva(action?) {
    this.videoMarketData.item_location_id =
      'liste_serie_simples_' + this.serie.position;
    this.statsService.send({
      name: 'item:clicked',
      payload: {
        item: this.videoMarketData,
      },
    });
    this.modalPubBva.closeModal();
  }

  hideModalPubBva(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalPubBva = false;
    this.modalShown = false;
    if (action === 'details') {
      this.videoMarketData.item_location_id =
        'liste_serie_simples_' + this.serie.position;
      this.statsService.send({
        name: 'item:clicked',
        payload: {
          item: this.videoMarketData,
        },
      });
      this.openLink('offres');
    }
    if (action === 'nextSerie') {
      if (this.userLifeCycle.isUserGuest) {
        this.openLink('series/entrainements');
      }
    }
  }

  hideModalPubBdc(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalPubBdc = false;
    this.modalShown = false;
    if (action === 'details') {
      this.videoMarketData.item_location_id =
        'liste_serie_simples_' + this.serie.position;
      this.statsService.send({
        name: 'item:clicked',
        payload: {
          item: this.videoMarketData,
        },
      });
      this.openLink('https://calendly.com/en_voiture_simone/calendly-2-', {target:'_system', forceOutLink: true})
    }
    if (action === 'nextSerie') {
      if (this.userLifeCycle.isUserGuest) {
        this.openLink('series/entrainements');
      }
    }
  }

  callHideModalPackPermis(action?) {
    this.videoMarketData.item_location_id =
      'liste_serie_simples_' + this.serie.position;
    this.statsService.send({
      name: 'item:clicked',
      payload: {
        item: this.videoMarketData,
      },
    });
    this.modalPubPackPermis.closeModal();
  }

  hideModalPubPackPermis(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalPubPackPermis = false;
    this.modalShown = false;
    this.videoMarketData.item_location_id =
      'liste_serie_simples_' + this.serie.position;
    if (action === 'details') {
      this.statsService.send({
        name: 'item:clicked',
        payload: {
          item: this.videoMarketData,
        },
      });
      this.openLink('offres');
    }
    if (action === 'nextSerie') {
      if (this.userLifeCycle.isUserGuest) {
        this.openLink('series/entrainements');
      }
    }
  }

  callHideModalStrike2(action?) {
    this.modalStrike2.closeModal();
  }

  hideModalStrike2(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalStrike2 = false;
    this.modalShown = false;
  }

  callHideModalStrike5(action?) {
    this.modalStrike5.closeModal();
  }

  hideModalStrike5(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalStrike5 = false;
    this.modalShown = false;
  }

  callHideModalStrike10(action?) {
    this.modalStrike10.closeModal();
  }

  hideModalStrike10(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalStrike10 = false;
    this.modalShown = false;
  }

  callHideModalSound(action?) {
    this.modalSound.closeModal();
  }

  callHideModalVideo(action?) {
    this.modalVideo.closeModal();
    this.showCtaPostVideo = false;
    if (this.videoModal === 'cpf') {
      this.displayModalPubCpf = true;
    } else if (this.videoModal === 'bva') {
      this.displayModalPubBva = true;
    } else if (this.videoModal === 'bdc') {
      this.displayModalPubBdc = true;
    } else if (this.videoModal === 'permis') {
      this.displayModalPubPackPermis = true;
    }
  }

  hideModalVideo(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalVideo = false;
    this.modalShown = false;
  }

  hideModalSound(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalSound = false;
    this.modalShown = false;
  }

  callHideModalQuitExam(action?) {
    if (action > 0) {
      this.canQuitExam = true;
    } else {
      this.canQuitExam = false;
    }
    this.modalQuitExam.closeModal();
  }

  callHideModalEndFirstSerie(action?) {
    this.modalEndFirstSerie.closeModal();
  }

  hideModalEndFirstSerie(action?) {
    this.addNewStyle(
      '.ion-page > ion-content > .scroll-content {overflow-y:auto !important;}'
    );
    this.displayModalEndFirstSerie = false;
    this.modalShown = false;
    // console.log(action);
    if (action === 'details') {
      this.soundMuted = true;
      this.statsService.send({
        name: 'session:completed',
        payload: { serie: this.serie },
      });
      this.openLink(
        'series/' +
          this.serieType +
          '/' +
          this.serieId +
          '/results/' +
          this.sessionId,
        { forceRoot: true }
      );
    }
    if (action === 'nextSerie') {
      this.nextSerie();
    }
  }

  handleVideoEvent(event: any) {
    // console.log('handleVideoEvent', event);
    if (!!event && !!event.clicked) {
      // click sur la pub
      this.handleVideoCTA();
    }
    if (!!event && !!event.ended) {
      this.callHideModalVideo();
    }
    if (!!event && !!event.close) {
      this.callHideModalVideo();
    }
  }

  handleVideoCTA() {
    this.callHideModalVideo();
    this.videoMarketData.item_location_id =
      this.videoMarketData.item_location_id + this.serie.position;
    this.statsService.send({
      name: 'item:clicked',
      payload: {
        item: this.videoMarketData,
      },
    });
    this.openLink('permis');
  }

  handleFailEvent(event: any) {
    if (!!event && !!event.status && event.status === 'failed') {
      alert('VIDEO MEDIA FAILED!');
      this.callHideModalVideo();
    }
  }

  nextSerie() {
    this.seriesService.seriesContext
      .getSeriesList(this.student)
      .then(seriesList => {
        const filteredSeriesOfCurrentType = seriesList.filter(
          elt => elt.type === this.serie.type
        );
        const filteredSeriesOfOtherType = seriesList.filter(
          elt => elt.type !== this.serie.type
        );
        const indexOfSerie = filteredSeriesOfCurrentType
          .map(function (e) {
            return e.position;
          })
          .indexOf(this.serie.position);
        let nextSerie = indexOfSerie + 1;
        let nextSerieFound: Serie = filteredSeriesOfCurrentType[nextSerie];

        if (nextSerie >= filteredSeriesOfCurrentType.length) {
          nextSerie = 0;
          nextSerieFound =
            filteredSeriesOfOtherType.length > 0
              ? filteredSeriesOfOtherType[nextSerie]
              : filteredSeriesOfCurrentType[nextSerie];
        }
        if (!!nextSerieFound) {
          // console.log(this.student.code, nextSerieFound.scope);
          this.openSerie(nextSerieFound.id);
        } else {
          console.error(
            'SeriePage No next serie found! - ' + JSON.stringify(this.serie)
          );
        }
      });
  }

  async openSerie(serieId) {
    const modes = {
      entrainements: 'Training',
      examens: 'Exam',
    };
    const serieDetails = await this.seriesService.seriesContext.getSerie(
      serieId,
      this.student,
      false
    );
    if (!!serieDetails) {
      this.sessionsService
        .openSessionBySerie(serieDetails, this.student, {
          mode: modes[this.serieType],
        })
        .subscribe(
          session => {
            const questionIndex = session.answersCount || 0;
            this.openLink(
              'series/' +
                this.serieType +
                '/' +
                session.serieId +
                '/' +
                questionIndex +
                '/' +
                session.id
            );
          },
          err => {
            console.error(
              'SeriePage openSerie openSessionBySerie: ' + JSON.stringify(err)
            );
          }
        );
    } else {
      // console.log('Empty serie showMarketVideo => ', this.showMarketVideo);
      if (this.showMarketVideo) {
        this.displayModalVideo = true;
        this.videoMarketData.item_location_id =
          this.videoMarketData.item_location_id + this.serie.position;
        this.statsService.send({
          name: 'item:viewed',
          payload: {
            item: this.videoMarketData,
          },
        });
      } else {
        this.openModalPack(
          {
            item_id: 'big_pack',
            item_promo_type: 'regular',
            item_location_id: 'marketingregular',
            item_location_format: 'modale',
            item_promo_content: 'reserved',
          },
          'marketingRegular'
        );
      }
      console.error(
        'SeriePage: User has code: true but server sent empty serie for serieId = ' +
          serieId
      );
    }
  }

  async openModalPub(nbGoodAnswers?: any, type?: any, noClose = false) {
    if (!type) {
      type = 'marketingRegular';
    }
    const props = {
      type: type,
      nbGoodAnswers: nbGoodAnswers,
      bannerInfo: {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: `question_${this.serieType === 'erreurs' ? 'erreurs' : this.serieType === 'examens' ? 'examen' : this.serieType === 'thematiques' ? 'thematique' : 'simples'}`,
        item_location_format: 'modale',
        item_promo_content: `pret_conduite`,
      },
    };

    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    // console.log('bannerInfo -> ', bannerInfo);
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  addNewStyle(newStyle) {
    let styleElement = document.getElementById('styles_js');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.setAttribute('type', 'text/css');
      styleElement.id = 'styles_js';
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    styleElement.appendChild(document.createTextNode(newStyle));
  }

  hideModalQuitExam() {
    this.pauseMedia();
    this.displayModalQuitExam = false;
    this.modalShown = false;
    if (!!this.timerBtn && !!this.timerBtn.nativeElement) {
      this.renderer.setStyle(
        this.timerBtn.nativeElement,
        'animation-play-state',
        'running'
      );
    }
    this.paused = false;
    if (this.canQuitExam) {
      this.stopTimer();
      this.openLink('series/' + this.serieType, { forceRoot: true });
    }
  }

  handleMediaEvent(event) {
    if (!!event && !!event.ended) {
      this.isEnded = true;
      this.startTimer();
      if (
        this.serieType !== 'examens' &&
        (!this.isMuted || this.mediaType === 'video')
      ) {
        this.showReloadBtn = true;
      }
    }
    if (!!event && !!event.mediaType) {
      this.mediaType = event.mediaType;
    }
  }

  handleMediaFailEvent(event) {
    if (!!event && !!event.status && event.status === 'failed') {
      if (this.networkService?.isOffline()) {
        this.navigationService.saveLinkToReload();
      }
    }
  }

  setMediaIsFullscreen(event) {
    this.isMediaFullscreen = event;
  }

  testhk() {
    this.navigationService.saveLinkToReload();
  }

  pauseMedia() {
    this.isPaused = !this.isPaused;
  }

  async muteMedia() {
    const student = await this.studentService.getProfil();
    this.isMuted = await this.configUserService.switchBoolean(student, 'mute');
  }

  stopMedia() {
    this.isStoped = !this.isStoped;
    this.isEnded = true;
  }

  reloadMedia() {
    if (this.serieType !== 'examens') {
      this.isEnded = false;
      this.isReloaded = !this.isReloaded;
    }
  }

  setMediaContainer() {
    // console.log('SETMEDIACONTAINER');
    // calcul la width/height des medias images car toutes les photos n'ont pas la même hauteur
    this.screenSizeX = window.innerWidth;
    if (window.innerWidth > 767) {
      this.screenSizeX = window.innerWidth - 40 - 20; // margin + padding + scrollbar
    }
    if (window.innerWidth >= 1010) {
      this.screenSizeX = 950 - 20; // padding
    }

    if (
      typeof this.question.question_img1_geometries !== 'undefined' &&
      this.question.question_img1_geometries !== null
    ) {
      this.ratioImg =
        this.screenSizeX /
        this.question.question_img1_geometries[this.imgSizeType].width;
      this.mediaWidth =
        this.question.question_img1_geometries[this.imgSizeType].width *
        this.ratioImg;
      this.mediaHeight =
        this.question.question_img1_geometries[this.imgSizeType].height *
        this.ratioImg;

      if (
        this.sizesByImgSizeType[this.imgSizeType] ===
        this.question.question_img1_geometries[this.imgSizeType].height
      ) {
        this.ratioImg = this.screenSizeX / this.maxWidthImg;
        this.mediaWidth = this.maxWidthImg * this.ratioImg;
        this.mediaHeight = this.maxHeightImg * this.ratioImg;
      }
    }
    // let isPano = false;
    // if (typeof this.question !== 'undefined') {
    //   if (typeof this.question.question_img1_geometries !== 'undefined' && this.question.question_img1_geometries !== null) {
    //     // console.log(this.currentQuestion.question_img1_geometries[this.imgSizeType].height, this.currentQuestion.question_img1_geometries[this.imgSizeType].width / this.currentQuestion.question_img1_geometries[this.imgSizeType].height);
    //     if (this.sizesByImgSizeType[this.imgSizeType] === this.question.question_img1_geometries[this.imgSizeType].height) {
    //       isPano = true;
    //     }
    //   }
    //   if (typeof this.question.question_img2_geometries !== 'undefined' && this.question.question_img2_geometries !== null) {
    //     // console.log(this.currentQuestion.question_img2_geometries[this.imgSizeType].height, this.currentQuestion.question_img2_geometries[this.imgSizeType].width / this.currentQuestion.question_img2_geometries[this.imgSizeType].height);
    //     if (this.sizesByImgSizeType[this.imgSizeType] === this.question.question_img2_geometries[this.imgSizeType].height) {
    //       isPano = true;
    //     }
    //   }
    //   if (typeof this.question.answer_img1_geometries !== 'undefined' && this.question.answer_img1_geometries !== null) {
    //     // console.log(this.currentQuestion.answer_img1_geometries[this.imgSizeType].height, this.currentQuestion.answer_img1_geometries[this.imgSizeType].width / this.currentQuestion.answer_img1_geometries[this.imgSizeType].height);
    //     if (this.sizesByImgSizeType[this.imgSizeType] === this.question.answer_img1_geometries[this.imgSizeType].height) {
    //       isPano = true;
    //     }
    //   }
    //   if (typeof this.question.answer_img2_geometries !== 'undefined' && this.question.answer_img2_geometries !== null) {
    //     // console.log(this.currentQuestion.answer_img2_geometries[this.imgSizeType].height, this.currentQuestion.answer_img2_geometries[this.imgSizeType].width / this.currentQuestion.answer_img2_geometries[this.imgSizeType].height);
    //     if (this.sizesByImgSizeType[this.imgSizeType] === this.question.answer_img2_geometries[this.imgSizeType].height) {
    //       isPano = true;
    //     }
    //   }
    // }
    // if (isPano) {
    //   this.mediaHeight = this.maxHeightImgPano * this.ratioImg;
    // } else {
    //   this.mediaHeight = this.maxHeightImg * this.ratioImg;
    // }

    if (!!this.mediaContainer && !!this.mediaContainer.nativeElement) {
      this.renderer.setStyle(
        this.mediaContainer.nativeElement,
        'width',
        '100%'
      );
      this.renderer.setStyle(
        this.mediaContainer.nativeElement,
        'max-height',
        this.mediaHeight + 'px'
      );
      this.renderer.setStyle(
        this.mediaContainer.nativeElement,
        'overflow',
        'hidden'
      );
      this.renderer.setStyle(
        this.mediaContainer.nativeElement,
        'position',
        'relative'
      );
    } else {
      if (this.retry < 3) {
        this.retry++;
        setTimeout(() => {
          this.setMediaContainer();
        }, 0);
      }
    }
  }

  triggerActionById(event) {
    if (!!event) {
      if (event.action === 'quitSerie' && event.value) {
        this.quitSerie();
      }
      if (event.action === 'mute') {
        this.muteMedia();
      }
    }
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async checkStorageLock(link: string) {
    let storageLocked = false;
    if (this.platform.is('cordova')) {
      storageLocked = !(await this.storageService.checkEnougthSpace());
    }
    if (storageLocked) {
      for (const lockedFeature of this.lockedFeatures) {
        if (link.includes(lockedFeature)) {
          this.openModalPack(null, 'modalStorage2');
          return true;
        }
      }
    }
    return false;
  }

  trackZendeskClicked() {
    this.statsService.send({
      name: 'item:clicked',
      payload: {
        item: {
          item_id: 'cdr_serie_help_click',
          cdr_question_id: this.question.id,
        },
      },
    });
  }

  async openLink(link, options?) {
    if (link === 'zendesk' && !this.student.code && !this.canZendesk) {
      this.trackZendeskClicked();
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingzendesk',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingZendesk'
      );
    } else {
      let storageLocked = false;
      let callbackUrl = null;

      if (link === 'zendesk') {
        this.trackZendeskClicked();
        options = { conversationTags : ["question_code", this.question.id] };
      }

      if (this.platform.is('cordova')) {
        storageLocked = await this.checkStorageLock(link);
      }
      if (!storageLocked) {
        callbackUrl = await this.navigationService.open(link, options);
      }
      if (!!callbackUrl && callbackUrl !== '') {
        this.openModalIframe(callbackUrl);
      }
    }
  }
}
